"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var core_1 = require("@material-ui/core");
var styles = function (theme) {
    var _a, _b, _c;
    return (0, core_1.makeStyles)({
        wrapper: {},
        media: (_a = {
                width: 350
            },
            _a[theme.breakpoints.down('sm')] = {
                width: 300,
                height: 300
            },
            _a),
        body1High: __assign(__assign({}, theme.typography.body1), { color: theme.palette.text.primary }),
        body2High: __assign(__assign({}, theme.typography.body2), { color: theme.palette.text.primary }),
        cardMainContainer: (_b = {
                display: 'flex',
                minWidth: '360px',
                justifyContent: 'center',
                marginBottom: theme.spacing(4)
            },
            _b[theme.breakpoints.down('sm')] = {
                width: '300px'
            },
            _b),
        tableContainer: (_c = {
                padding: theme.spacing(3)
            },
            _c[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(1)
            },
            _c),
        gameNameContainer: {
            paddingLeft: theme.spacing(1),
            maxWidth: '300px'
        },
        cardContainer: {
            boxShadow: 'none',
            border: '1px solid',
            borderColor: theme.palette.divider,
            borderRadius: 'unset'
        },
        endMessageContainer: {
            justifyContent: 'center',
            width: '100%'
        },
        endMessage: {
            margin: theme.spacing(4)
        },
        tableCell: {
            borderColor: theme.palette.grey['200'],
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            paddingRight: theme.spacing(1.5),
            paddingLeft: theme.spacing(1.5)
        }
    });
};
exports.styles = styles;
//# sourceMappingURL=styles.js.map